import { Roles } from "../model/roles";
import { UserData } from "../model/user-data";
import { DcMaintainenceResponse } from './dc-maintainence-response';
import { StoreMaintainenceResponse } from './store-maintainence-response';
export class UsersDataResponse {

    userData:UserData;
    roleAccessIds: number[];
    dcNumbers:number[]
    storeNumbers:string[]
    stores:StoreMaintainenceResponse[];
    dcLocations:DcMaintainenceResponse[];
    dcUsersList:any;
    lstAccess:Roles[];
    roleId: number;
    roleName:string;
 
   


}
